module.exports = __webpack_public_path__ + "static/media/2020.7.12七月主题党日.a47a62d8.jpg";